import {
  reqGetHallByIdentifier,
  reqGetHallByInviteLink,
} from '@weblite/ts-action/hall'
import {
  reqJoinHall,
  reqJoinHallViaLink,
  ResJoinHallPayload,
  ResJoinHallViaLinkPayload,
} from '@weblite/ts-action/subscription'
import { ResponseAction } from '@weblite/ts-action'
import { inviteLinkRegex, usernameRegex } from '$logic/router/url'
import { postApi } from '$setup/http'

export type JoinFnType = (
  identifier: string,
) => Promise<ResponseAction<ResJoinHallPayload | ResJoinHallViaLinkPayload>>

export const canJoinHallUsingLinkOrIdentifier = async (
  linkOrIdentifier: string,
): Promise<{ joinFn?: JoinFnType; canJoin: boolean }> => {
  if (inviteLinkRegex.test(linkOrIdentifier)) {
    // '/+:inviteLink'
    const link = new URL(linkOrIdentifier).pathname.slice(2)

    const response = await postApi(reqGetHallByInviteLink({ link }))
    if (response.error?.code) return { joinFn: undefined, canJoin: false }

    const hall = response?.payload?.hall
    if (hall)
      return {
        joinFn: () => postApi(reqJoinHallViaLink({ link })),
        canJoin: true,
      }
  } else {
    // '/:identifier'
    // pure identifier
    const identifier = usernameRegex.test(linkOrIdentifier)
      ? new URL(linkOrIdentifier).pathname.slice(1)
      : linkOrIdentifier

    if (identifier) {
      const response = await postApi(reqGetHallByIdentifier({ identifier }))

      const hall = response?.payload?.hall
      if (hall) {
        const { roomId } = hall
        return { joinFn: () => postApi(reqJoinHall({ roomId })), canJoin: true }
      }
    }
  }

  return { joinFn: undefined, canJoin: false }
}
